export const defaultCoverImage = {
  dark: 'https://cdn.realworld.to/general-files/black.png',
  light: 'https://cdn.realworld.to/general-files/white.png',
  card: 'https://cdn.realworld.to/user-files/aVsmwofZ5Orhj6OoqMBSug/22-01-19-05-44-08_bCn1OzzeT64.jpg'
};
